import { PureComponent } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { HistoryUtil } from '@vzmi/component_ec_nodejs_util/dist/lib'
import UiStateContainer, { defaultUiContextCosumer } from '@vzmi/ec-react-ui-state-container'
import {
  PROPOSAL_REVIEW_STATUS,
  PROPOSAL_TYPE,
  PROPOSAL_SECTION_TITLE,
  PRODUCT_SHIP_TYPE
} from '@vzmi/shp_shared_compo/constants/proposal'
import { Element, animateScroll, scrollSpy } from 'react-scroll'
import { Toast, Button, FormLoader, ProposalSection } from '@vzmi/shp_shared_compo'
import { I13nDiv } from '@vzmi/ec-react-i13n'

import styles from './FlowController.css'
import { COMPOSE_SECTION_OFFSET } from '../Shared'
import {
  isComposingStatus,
  getScopedFieldNameByShipType,
  getUploadStateByUI,
  getListingPreviewPage
} from '../Common/ProposalForm/Shared/util'
import { newProposalI13nConf } from '../../../../../conf/i13nConf'
import {
  SKIP_REQUIRED_FIELD,
  TOAST_DURATION,
  PROPOSAL_PHASE_TYPE,
  PAGE_FLOW,
  PROPOSAL_LISTING_FORM_KEY,
  PROPOSAL_TYPE_NAME
} from '../../../constants/proposalTypes'
import Tip from '../Common/Tip'
import { Field, FormValueSelector } from '../../Common/forms'
import {
  scrollToErrorElement,
  promisifySubmitResult,
  createErrorToast
} from '../../../lib/FormHelper'
import PageFlow from '../Common/PageFlow/PageFlow'
import { When } from '../../Common/Form'
import { getLogger } from '../../../../lib/browserLogger'
import { scrollTo, scrollToElement } from '../../../../lib/renderUtil'
import { ProductListingCompletionWithTimer } from './ProductListingCompletion/ProductListingCompletion'
import SPBaseModule from '../../../lib/SPBaseModule'
import HeadingWithId from '../Common/HeadingWithId/HeadingWithId'
import FixedSection from '../Common/ProposalForm/FixedSection/FixedSection'
import ScrollAnchorLink from '../Common/ProposalForm/ScrollAnchorLink/ScrollAnchorLink'
import Info from './Info'
import Spec from './Spec'
import Media from './Media/Media'
import ProductDetail from './ProductDetail'
import { isNewListingProposal } from '../../../../lib/proposalHelper'
import { SHIP_TYPE_ID_FIELD_NAME } from '../../../lib/ReduxFormSelectors/ProposalListingForm'
import { loadLocal, removeLocal } from '../../../lib/localStorageHelper'
import ProposalFormHead from '../Common/ProposalFormHead/ProposalFormHead'
import { FRONT_END_DEFINED_ERROR_CODE } from '../../../constants/globalTypes'

const PROPOSAL_LISTING_FORM_ID = 'compose-form'
const logger = getLogger({ name: PROPOSAL_LISTING_FORM_ID })

const FORM_SECTION_CONFIG = {
  // 新增賣場
  [PROPOSAL_TYPE.NEW_LISTING]: [
    {
      name: 'proposal-and-listing',
      title: PROPOSAL_SECTION_TITLE.PROPOSAL_AND_LISTING,
      i13nLabel: 'link_proposal-and-listing',
      component: Info
    },
    {
      name: 'product-and-price',
      title: PROPOSAL_SECTION_TITLE.PRODUCT_AND_PRICE,
      i13nLabel: 'link_product-and-price',
      component: ProductDetail
    },
    {
      name: 'photo-and-spec',
      title: PROPOSAL_SECTION_TITLE.PHOTO_AND_SPEC,
      i13nLabel: 'link_photo-and-spec',
      component: Spec
    },
    {
      name: 'video-and-detail',
      title: PROPOSAL_SECTION_TITLE.VIDEO_AND_DETAIL,
      i13nLabel: 'link_video-and-detail',
      component: Media
    }
  ],
  // 新增商品
  [PROPOSAL_TYPE.NEW_PRODUCT]: [
    {
      name: 'proposal-only',
      title: PROPOSAL_SECTION_TITLE.PROPOSAL_ONLY,
      i13nLabel: 'link_proposal-only',
      component: Info
    },
    {
      name: 'product-and-price',
      title: PROPOSAL_SECTION_TITLE.PRODUCT_AND_PRICE,
      i13nLabel: 'link_product-and-price',
      component: ProductDetail
    },
    {
      name: 'photo-and-spec',
      title: PROPOSAL_SECTION_TITLE.PHOTO_AND_SPEC,
      i13nLabel: 'link_photo-and-spec',
      component: Spec
    },
    {
      name: 'product-detail',
      title: PROPOSAL_SECTION_TITLE.PRODUCT_DETAIL,
      i13nLabel: 'link_product-detail',
      component: Media
    }
  ]
}

const getSaveAsDraftBtnSelector = select => ({
  id: select('id'),
  reviewStatus: select('reviewStatus')
})
// 儲存草稿 按鈕
const SaveAsDraftButton = props => {
  const {
    disabled,
    proposalType,
    onClick
  } = props

  return (
    <FormValueSelector
      selector={getSaveAsDraftBtnSelector}
    >
      {values => {
        const {
          reviewStatus,
          id
        } = values

        const showSaveAsDraftBtn = isComposingStatus({ reviewStatus }) || !id

        if (showSaveAsDraftBtn) {
          const i13nModel = {
            category: proposalType,
            action: `${proposalType}_${PROPOSAL_PHASE_TYPE.COMPOSE}`,
            label: 'proposal_composed'
          }

          return (
            <I13nDiv
              i13nModel={i13nModel}
              className={styles.saveAsDraftBtn}
            >
              <Button
                size='large'
                disabled={disabled}
                data-role='save-as-draft-button'
                buttonType='outline'
                onClick={onClick}
              >
                儲存草稿
              </Button>
            </I13nDiv>
          )
        }
      }}
    </FormValueSelector>
  )
}

class FormFixedTop extends PureComponent {
  componentDidMount () {
    scrollSpy.update()

    animateScroll.scrollTo(1, {
      offset: COMPOSE_SECTION_OFFSET.FIRST_SECTION_OFFSET,
      smooth: true
    })
  }

  render () {
    const {
      ui,
      match: { params: { phase } },
      pageFlow,
      proposalType,
      handleReturnEdit,
      handleSavingDraft,
      reduxFormState
    } = this.props

    const { isCurrent } = pageFlow
    const { isMediaUploading } = getUploadStateByUI(ui)
    const proposalTypeName = PROPOSAL_TYPE_NAME[proposalType]
    const proposalId = _.get(reduxFormState, 'values.id')
    const { uri: listingPreviewUri, target: listingPreviewTarget } = getListingPreviewPage(proposalId)
    switch (phase) {
      case PROPOSAL_PHASE_TYPE.OVERVIEW: {
        return null
      }
      case PROPOSAL_PHASE_TYPE.COMPOSE:
      default: {
        return (
          <FixedSection className={styles.FormFixedTop}>
            <div
              key='top'
              className={styles.fixedSecTop}
            >
              <div
                key='header'
                className={styles.fixedSecHeader}
              >
                <Field
                  key='id'
                  name='id'
                  component={props => {
                    const proposalId = props.input.value
                    const subtitle = proposalId ? `提案編號：${proposalId}` : ''
                    return (
                      <HeadingWithId
                        subtitle={subtitle}
                        title={
                          isCurrent(PAGE_FLOW.EDIT)
                            ? `${proposalTypeName}提案`
                            : `提案資訊確認-${proposalTypeName}`
                        }
                      />
                    )
                  }}
                />
              </div>
              <div
                key='buttons'
                className={styles.fixedSecButtons}
              >
                <When
                  key='draft'
                  value={isCurrent(PAGE_FLOW.EDIT)}
                  isTrue
                >
                  <SaveAsDraftButton
                    proposalType={proposalType}
                    disabled={isMediaUploading}
                    onClick={handleSavingDraft}
                  />
                </When>
                <When
                  key='edit'
                  value={isCurrent(PAGE_FLOW.CONFIRM)}
                  isTrue
                >
                  <When
                    value={isNewListingProposal(proposalType)}
                    isTrue
                  >
                    <Button
                      data-role='listing-preview'
                      size='large'
                      onClick={() => window.open(listingPreviewUri, listingPreviewTarget)}
                    >
                      賣場預覽
                    </Button>
                  </When>
                  <Button
                    data-role='back-to-edit-button'
                    size='large'
                    buttonType='outline'
                    onClick={handleReturnEdit}
                  >
                    返回編輯
                  </Button>
                </When>
              </div>
            </div>
            {
              isCurrent(PAGE_FLOW.EDIT) && (
                <ul key='sections'>
                  {
                    _.map(
                      _.get(FORM_SECTION_CONFIG, proposalType),
                      (section, idx) => {
                        const {
                          i13nLabel,
                          title,
                          name,
                          name: id
                        } = section

                        // offset需要減去既定的header高度
                        const offset = idx === 0
                          ? COMPOSE_SECTION_OFFSET.FIRST_SECTION_OFFSET
                          : 0

                        const i13nModel = {
                          category: proposalType,
                          action: `${proposalType}_${PROPOSAL_PHASE_TYPE.COMPOSE}`,
                          label: i13nLabel
                        }

                        return (
                          <ScrollAnchorLink
                            spy
                            isDynamic
                            key={id}
                            id={id}
                            to={name}
                            duration={400}
                            activeClass='active'
                            smooth={'easeInOutCubic'}
                            offset={offset + COMPOSE_SECTION_OFFSET.SECTION_OFFSET}
                          >
                            <I13nDiv
                              i13nModel={i13nModel}
                            >
                              {title}
                            </I13nDiv>
                          </ScrollAnchorLink>
                        )
                      })}
                </ul>
              )
            }
          </FixedSection>
        )
      }
    }
  }
}

const FormFixedTopContainer = UiStateContainer.createUi(FormFixedTop, defaultUiContextCosumer)

const FormHeadContainer = UiStateContainer.createUi(ProposalFormHead, defaultUiContextCosumer)

class FormBody extends PureComponent {
  render () {
    const {
      handleComplete,
      ...restProps
    } = this.props
    const proposalType = this.props.proposalType
    return (
      <form
        key='form'
        autoComplete='off'
        onSubmit={handleComplete}
      >
        {
          _.map(_.get(FORM_SECTION_CONFIG, proposalType), section => {
            const {
              title,
              name,
              name: id,
              className,
              component: Component
            } = section
            return (
              <ProposalSection
                key={id}
                title={title}
                id={id}
                data-role={id}
              >
                <Element
                  name={name}
                  className={className}
                >
                  <Component
                    {...restProps}
                    proposalType={proposalType}
                  />
                </Element>
              </ProposalSection>
            )
          })
        }
      </form>
    )
  }
}

const FormBodyContainer = connect(state => {
  const location = _.get(state, 'router.location', {})
  const { fromClone } = HistoryUtil.retrieveQueryParams({ location })
  return { fromClone: fromClone === 'true' }
})(UiStateContainer.createUi(FormBody, defaultUiContextCosumer))

/**
   * 快速到貨(進倉) shipType61 以外的 shipType 沒有 isOutRightPurchase Field,
   * 所以都是 false
   */
const getIsOutRightPurchase = (select) => {
  const shipTypeId = +select(SHIP_TYPE_ID_FIELD_NAME)
  if (shipTypeId === PRODUCT_SHIP_TYPE.EXPRESS_24HR) {
    const isOutRightFieldName = getScopedFieldNameByShipType(shipTypeId, 'product.isOutrightPurchase')
    return select(isOutRightFieldName)
  }
  return false
}

class FormCompletion extends PureComponent {
  render () {
    return (
      <FormValueSelector
        selector={select => ({
          isPM: select('setting.user.identity.isPM'),
          id: select('id'),
          proposalType: select('setting.proposalType'),
          expiredTs: select('expiredTs'),
          isOutrightPurchase: getIsOutRightPurchase(select),
          isThresholdFreebie: select('listing.isThresholdFreebie')
        })}
      >
        {
          values => {
            const allProps = _.merge({}, this.props, values)
            return (
              <ProductListingCompletionWithTimer
                {...allProps}
              />
            )
          }
        }
      </FormValueSelector>
    )
  }
}

class FormFoot extends PureComponent {
  render () {
    const {
      ui,
      proposalType,
      pageFlow: {
        isCurrent
      },
      match: {
        params: { phase }
      },
      handleSavingDraft,
      handleSaveWithoutSubmit,
      handlePendingReview,
      handleComplete
    } = this.props

    const { isMediaUploading } = getUploadStateByUI(ui)
    switch (phase) {
      case PROPOSAL_PHASE_TYPE.OVERVIEW: {
        return null
      }
      case PROPOSAL_PHASE_TYPE.COMPOSE:
      default: {
        return (
          <section
            key='cta'
            className={styles.CTA}
          >
            <When
              key='confirm'
              value={isCurrent(PAGE_FLOW.CONFIRM)}
              isTrue
            >
              <Button
                key='submit'
                data-role='submit-pending-review-proposal-button'
                size='large'
                color='primary'
                onClick={handlePendingReview}
              >
                送出提案
              </Button>
              <Button
                key='save'
                data-role='save-without-complete-proposal-button'
                size='large'
                buttonType='outline'
                onClick={handleSaveWithoutSubmit}
              >
                儲存暫不提案
              </Button>
            </When>
            <When
              key='edit'
              value={isCurrent(PAGE_FLOW.EDIT)}
              isTrue
            >
              <Button
                key='submit'
                disabled={isMediaUploading}
                data-role='complete-proposal-button'
                size='large'
                color='primary'
                onClick={handleComplete}
              >
                完成提案
              </Button>
              <SaveAsDraftButton
                proposalType={proposalType}
                disabled={isMediaUploading}
                onClick={handleSavingDraft}
              />
            </When>
            <Tip
              key='info'
              type='info'
              className={styles.CTATip}
            >
              {
                isCurrent(PAGE_FLOW.EDIT)
                  ? '完成提案後，需確認資訊才會送出審核'
                  : (
                    <>
                      送出提案單，即視為已詳閱、了解並同意提案同意書之全部內容，
                      <br />
                      並應確保所提報及上架之商品符合本平台刊登規範及相關法令、政令之規定；
                      <br />
                      提案一經送出，內容即不得再行變更。
                    </>
                  )
              }
            </Tip>
          </section>
        )
      }
    }
  }
}

const FormFootContainer = UiStateContainer.createUi(FormFoot, defaultUiContextCosumer)
const getSavedFormKey = proposalType => {
  switch (proposalType) {
    case PROPOSAL_TYPE.NEW_LISTING:
    case PROPOSAL_TYPE.NEW_PRODUCT:
      return PROPOSAL_LISTING_FORM_KEY
  }
  return ''
}

export class FlowController extends SPBaseModule {
  /**
   * Prevent React setState on unmounted Component
   * @see https://www.robinwieruch.de/react-warning-cant-call-setstate-on-an-unmounted-component/
   */
  _isMounted = false

  componentDidMount () {
    this._isMounted = true
    // ProductListingForm 起始點
    this.initForm()
  }

  componentWillUnmount () {
    this._isMounted = false
  }

  setIsLocallyLoading = (bool) => {
    if (this._isMounted) {
      this.setIsLoading(bool)
    }
  }

  initForm = async () => {
    const {
      getFormData,
      loadForm,
      proposalType
    } = this.props

    this.setIsLocallyLoading(true)

    try {
      let localFormData = {}

      /**
       * 如果 localStorage 中有存 redux-form data, 優先使用
       * 從localStorage 中取出後就刪除在 localStorage 中的 data
       */
      const localFormKey = getSavedFormKey(proposalType)
      const formValuesFromLocalStorage = localFormKey ? loadLocal(localFormKey) : null
      if (formValuesFromLocalStorage) {
        removeLocal(localFormKey)
        localFormData = formValuesFromLocalStorage
      } else {
        localFormData = await getFormData()
      }

      this.handlePageMoveTo(PAGE_FLOW.EDIT)
      loadForm(localFormData)
    } catch (err) {
      const feature = _.get(this.props, 'match.params.feature')
      logger.error({ tag: 'FlowController', msg: `loadFormData failed, feature: ${feature} , err: ${err}` })
      this.handlePageMoveTo(PAGE_FLOW.ERROR, {
        error: {
          message: '連結有誤，未攜帶提案資訊'
        }
      })
    }

    this.setIsLocallyLoading(false)
  }

  handleInvalidForm = (error) => {
    const isCopyImageExceedLimit = _.get(error, 'result[0].code') === FRONT_END_DEFINED_ERROR_CODE.FE_IMG_EXCEED_LIMIT
    this.setIsLocallyLoading(false)
    if (isCopyImageExceedLimit) {
      scrollToElement(document.querySelector('[data-role="editor"]'), COMPOSE_SECTION_OFFSET.SECTION_OFFSET)
    } else {
      scrollToErrorElement(COMPOSE_SECTION_OFFSET.SECTION_OFFSET)
    }

    /**
     * 40100003與40100004 在 middlewares 中已經有拋出 toast 了，
     * 所以不需要再出現 toast
     */
    const resultErrorCode = _.get(error, 'result[0].code')
    if (resultErrorCode !== 40100003 &&
        resultErrorCode !== 40100004) { // FIXME: this may need to centralize in somewhere
      createErrorToast({
        message: error.message,
        error
      })
    }
  }

  // 返回編輯
  handleReturnEdit = () => {
    this.handlePageMoveTo(PAGE_FLOW.EDIT)
  }

  // 儲存草稿
  handleSavingDraft = async () => {
    const props = this.props
    const { onSavingDraftSubmit, handleSubmit } = props
    const triggerFormSubmit = promisifySubmitResult(handleSubmit(onSavingDraftSubmit))
    /**
     * 略過必填的 validation，
     * field value 已經有值的還是要進行 validation
    */
    props.change(SKIP_REQUIRED_FIELD, true)
    /**
     * 一般 field 都是 touched 就會顯示 syncErrors，
     * 但是 msrp, price, cost 這幾欄不會，
     * 所以需要 'mustShowFormError' 這個 flag 強制它們在要提交時顯示出錯誤訊息
     */
    props.change('mustShowFormError', true)
    try {
      const returnFormData = await triggerFormSubmit()
      /**
       * 確定提交成功後，
       * 'mustShowFormError' 要改回 false，
       * 這樣 msrp, price, cost 的錯誤訊息才不會恆久顯示
       */
      props.change('mustShowFormError', false)
      const { id, reviewStatus } = returnFormData
      switch (reviewStatus) {
        case PROPOSAL_REVIEW_STATUS.COMPOSING:
        case PROPOSAL_REVIEW_STATUS.DRAFT: {
          Toast.success(
            <div
              style={{
                width: 270,
                textAlign: 'left',
                lineHeight: '22px'
              }}
            >
              草稿儲存成功！
              <br />
              查詢可至&quot;提案單查詢&quot;系統，輸入提案編號：
              {id}
            </div>,
            { duration: TOAST_DURATION }
          )
          break
        }
        default:
          break
      }
      this.setIsLocallyLoading(false)
      return returnFormData
    } catch (error) {
      logger.debug('handleDraftSubmit errors', error)
      this.handleInvalidForm(error)
    }
  }

  // 儲存暫不提案
  handleSaveWithoutSubmit = async () => {
    const props = this.props
    const { onSaveWithoutSubmit, handleSubmit } = props
    /**
     * handleSubmit invoke 時會進行 validation，
     * 通過才會執行傳進去的 onFormSubmit
    */
    props.change(SKIP_REQUIRED_FIELD, false)
    const triggerFormSubmit = promisifySubmitResult(handleSubmit(onSaveWithoutSubmit))
    let returnFormData
    try {
      returnFormData = await triggerFormSubmit()
      return returnFormData
    } catch (error) {
      logger.debug('handleSaveWithoutSubmit errors', error)
      this.handleInvalidForm(error)
    }
  }

  // 完成提案
  handleComplete = async () => {
    const props = this.props
    const { onFormSubmit, handleSubmit } = props
    /**
     * handleSubmit invoke 時會進行 validation，
     * 通過才會執行傳進去的 onFormSubmit
    */
    const triggerFormSubmit = promisifySubmitResult(handleSubmit(onFormSubmit))

    // 完成提案時，reviewStatus應帶draft
    props.change(SKIP_REQUIRED_FIELD, false)
    props.change('mustShowFormError', true)

    try {
      const returnFormData = await triggerFormSubmit()
      const { id } = returnFormData
      if (id) {
        this.handlePageMoveTo(PAGE_FLOW.CONFIRM)
      }
      return returnFormData
    } catch (error) {
      logger.debug('handleComplete errors', error)
      this.handleInvalidForm(error)
    }
  }

  // 送出提案
  // 更新既有提案資訊，將提案單狀態設為待審核，並進入提案送出成功頁
  handlePendingReview = async () => {
    const props = this.props
    const { onPendingReviewSubmit, handleSubmit } = props
    /**
     * handleSubmit invoke 時會進行 validation，
     * 通過才會執行傳進去的 onFormSubmit
    */
    const triggerFormSubmit = promisifySubmitResult(handleSubmit(onPendingReviewSubmit))
    try {
      const returnFormData = await triggerFormSubmit()
      this.handlePageMoveTo(PAGE_FLOW.SUCCESS)
      return returnFormData
    } catch (error) {
      logger.debug('handlePendingReview errors', error)
      this.handleInvalidForm(error)
    }
  }

  // defines to what to do when page flow changes
  handlePageMoveTo = (pageFlowName, state) => {
    const {
      i13nMethods: {
        sendI13nPageViewByPageKey
      },
      proposalType
    } = this.props

    // send Pageview by page flow name
    sendI13nPageViewByPageKey(`${proposalType}-${pageFlowName}`, newProposalI13nConf)

    if (pageFlowName) {
      switch (pageFlowName) {
        case PAGE_FLOW.EDIT: {
          // when page on edit, set readOnly to false
          scrollTo(0)
          this.props.change('setting.readOnly', false)
          break
        }
        case PAGE_FLOW.CONFIRM: {
          // when page on confirm, set readOnly to true
          scrollTo(0)
          this.props.change('setting.readOnly', true)
          break
        }
        default: {
          break
        }
      }
      if (this.pageFlow) {
        this.pageFlow.moveTo(pageFlowName, state)
      }
    }
  }

  isFormLoading = () => {
    return this.state.isLoading || this.props.submitting
  }

  render () {
    return (
      <div
        className={styles.FlowController}
        data-role={PROPOSAL_LISTING_FORM_ID}
      >
        <UiStateContainer>
          <FormLoader
            isLoading={this.isFormLoading()}
            fixed
          >
            <PageFlow
              ref={r => (this.pageFlow = r)}
              FixedTopComponent={FormFixedTopContainer}
              HeadComponent={FormHeadContainer}
              FormComponent={FormBodyContainer}
              FootComponent={FormFootContainer}
              CompletionComponent={FormCompletion}
              handleComplete={this.handleComplete}
              handleReturnEdit={this.handleReturnEdit}
              handleSavingDraft={this.handleSavingDraft}
              handlePendingReview={this.handlePendingReview}
              handleSaveWithoutSubmit={this.handleSaveWithoutSubmit}
              {...this.props}
            />
          </FormLoader>
        </UiStateContainer>
      </div>
    )
  }
}

FlowController.propTypes = {
  loadForm: PropTypes.func.isRequired,
  getFormData: PropTypes.func.isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
}

export default FlowController
